'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { planAdditionalCostSelector } from '../../selectors/PricingSelectors';
import { hasProductVersionInProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { HighlightedPriceDisplay } from '../common/pricing/HighlightedPriceDisplay';

const HighlightedMerchPriceDisplay = (_ref) => {
  let {
    skuId,
    quantityPackSkuId,
    quantityPackQuantity,
    queryParamTerm,
    productLine,
    style = {}
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["skuId", "quantityPackSkuId", "quantityPackQuantity", "queryParamTerm", "productLine", "style"]);

  const productConfigurations = [createProductConfig({
    skuId
  })];
  if (quantityPackSkuId && quantityPackQuantity > 0) productConfigurations.push(createProductConfig({
    skuId: quantityPackSkuId,
    quantity: quantityPackQuantity
  }));
  const showingOnlyAdditionalCost = useSelector(state => hasProductVersionInProductInventorySelector(state, {
    skuId
  }));
  const pricingInfo = useSelector(state => planAdditionalCostSelector(state, {
    productConfigurations,
    queryParamTerm
  }));
  return /*#__PURE__*/_jsx(HighlightedPriceDisplay, Object.assign({
    pricingInfo: pricingInfo,
    skuId: skuId,
    productLine: productLine,
    wrapperStyle: style,
    showingOnlyAdditionalCost: showingOnlyAdditionalCost
  }, rest));
};

HighlightedMerchPriceDisplay.propTypes = {
  skuId: PropTypes.number.isRequired,
  queryParamTerm: PropTypes.string,
  productLine: PropTypes.string,
  style: PropTypes.object,
  quantityPackSkuId: PropTypes.number,
  quantityPackQuantity: PropTypes.number
};
export default HighlightedMerchPriceDisplay;